import Container, {
  ContainerProps,
  containerClasses,
} from '@mui/material/Container';
import { styled } from '@mui/material/styles';

import { FOOTER_HEIGHT } from '~/components/Footer/styles';

export const StyledOuterContainer = styled('div')({
  height: `calc(100% - ${FOOTER_HEIGHT}px)`,
  overflowY: 'auto',
});

export const StyledContainer = styled(Container)<ContainerProps>(
  ({ theme }) => ({
    [`&.${containerClasses.root}`]: {
      padding: theme.spacing(2),
    },
  }),
);
